import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getProfile, getCurrentUser } from '../../utils/auth';
import { getPosts } from '../../utils/storage';
import { Avatar } from 'antd';
import './index.css';

export default function UserPage(){
  const { username } = useParams();
  const profile = getProfile(username) || { displayName: username, bio: '', website: '', avatarUrl: '' };
  const posts = (getCurrentUser()?.username === username) ? getPosts().filter(p => p.author === username) : [];

  return (
    <div className="container">
      <div className="user-header">
        <Avatar src={profile.avatarUrl || '/avatar-placeholder.svg'} size={96} />
        <div className="user-meta">
          <h2>{profile.displayName || username}</h2>
          <p className="user-bio">{profile.bio}</p>
          {profile.website ? <a href={profile.website} target="_blank" rel="noreferrer">{profile.website}</a> : null}
        </div>
      </div>

      <section className="user-posts">
        <h3>文章 ({posts.length})</h3>
        <ul>
          {posts.map(p => (
            <li key={p.id}><Link to={`/post/${p.id}`}>{p.title}</Link> <span className="post-meta">{new Date(p.createdAt).toLocaleDateString()}</span></li>
          ))}
          {posts.length === 0 && <li className="empty">该作者尚未发表任何文章</li>}
        </ul>
      </section>
    </div>
  );
}
